import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, X } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

export const SearchBar = ({ onSearch, placeholder }) => {
  const [query, setQuery] = useState('');
  const { t } = useLanguage();
  
  const handleSearch = () => {
    onSearch(query);
  };
  
  const handleClear = () => {
    setQuery('');
    onSearch('');
  };
  
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };
  
  return (
    <div className="relative w-full">
      <div className="relative flex items-center">
        <Search className="absolute left-3 sm:left-4 h-4 sm:h-5 w-4 sm:w-5 text-muted-foreground" />
        <Input
          type="text"
          placeholder={placeholder || t('searchPlaceholder')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          className="pl-9 sm:pl-12 pr-20 sm:pr-24 h-12 sm:h-14 text-sm sm:text-base border-2 focus:border-primary transition-colors"
          data-testid="library-search-input"
        />
        <div className="absolute right-2 flex items-center space-x-1">
          {query && (
            <Button
              variant="ghost"
              size="sm"
              onClick={handleClear}
              className="h-8 w-8 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          )}
          <Button
            onClick={handleSearch}
            size="sm"
            className="h-8 sm:h-10 px-2 sm:px-4 text-xs sm:text-sm"
          >
            {t('search')}
          </Button>
        </div>
      </div>
    </div>
  );
};